<template>
  <el-card class="mtop">
    <div ref="chartContainer" style="width: 100%; height: 400px;" />
  </el-card>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'EchartDay',
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '等级流失'
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['次日', '3日', '4日', '5日', '6日', '7日', '15日', '30日'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          }
        },
        toolbox: {
          show: true,
          feature: {
          // dataView: { readOnly: false },
            magicType: { type: ['line', 'bar'] },
            // restore: {},
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '次日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '3日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '4日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '5日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '6日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '7日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '15日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          },
          {
            name: '30日',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}%' // 显示数值
            }
          }
        ]
      }
      this.chart.setOption(this.option)
    },
    refresh(res) {
      const country = res.data.country
      const tableData = res.data.data
      const logCount = res.data.logCount
      const levelData = []
      const keys = [1, 2, 3, 4, 5, 6, 14, 29]
      const date = []
      const dayStat = {
        d1: [],
        d2: [],
        d3: [],
        d4: [],
        d5: [],
        d6: [],
        d14: [],
        d29: []
      }

      tableData.forEach(res => {
        levelData[res.level] = {
          level: res.level,
          login: logCount,
          d1: 0,
          d2: 0,
          d3: 0,
          d4: 0,
          d5: 0,
          d6: 0,
          d14: 0,
          d29: 0
        }
      })
      for (const i in tableData) {
        const val = tableData[i]
        for (const l in levelData) {
          const ld = levelData[l]
          if (ld.level === val.level) {
            if (val.count > 0) {
              const rate = val.count / ld.login * 100
              ld['d' + val.diff_day] = Math.floor(rate * 100) / 100
            }
          }
        }
      }

      for (const l in levelData) {
        date.push('等级' + l)
        const val = levelData[l]
        for (const k in keys) {
          dayStat['d' + keys[k]].push(val['d' + keys[k]])
        }
      }

      this.option.xAxis.data = date
      this.country = [{ value: '', label: '全部' }]
      for (const i in country) {
        this.country.push({ value: i, label: country[i] })
      }
      for (const k in keys) {
        this.option.series[k].data = dayStat['d' + keys[k]]
      }
      this.chart.setOption(this.option, true)
      return levelData
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 10px;
}
</style>
